import { Typography } from "@mui/material";
import { useState } from "react";
import Modal from "../ui/Modal";
import { useSnackbar } from "notistack";

const SubmitQuiz = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const submitQuiz = () => {
    props.close();
  };
  return (
    <Modal
      {...props}
      title="Submit Quiz"
      actionText="Submit"
      loading={loading}
      action={submitQuiz}
    >
      <Typography>
        You have completed 1/5 questions, are you sure you want to submit the
        quiz?
      </Typography>
    </Modal>
  );
};

export default SubmitQuiz;
